import { render, staticRenderFns } from "./PlannedLevelStatsSpellsKnown.vue?vue&type=template&id=3974c248&scoped=true&"
import script from "./PlannedLevelStatsSpellsKnown.vue?vue&type=script&lang=js&"
export * from "./PlannedLevelStatsSpellsKnown.vue?vue&type=script&lang=js&"
import style0 from "./PlannedLevelStatsSpellsKnown.vue?vue&type=style&index=0&id=3974c248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3974c248",
  null
  
)

export default component.exports